export default {
    emitters: {
        getDeferredTasks(params) {
            const { type, fromId, count, ..._payload } = params
            const requestParams = {
                type, fromId, count,
                payload: {
                    type: _payload.payload.type,
                    data: _payload.payload.data
                }
            }
            this.log('getDeferredTasks: > ' + JSON.stringify(requestParams))
            return new Promise((resolve, reject) => {
                try {
                    this.socket.emit('get-deferred-tasks', requestParams, (data) => {
                        // console.log("🚀 ~ tasks.js:19 ~ getDeferredTasks ~ data:", data)
                        // this.log('getDeferredTasks: < ' + JSON.stringify(data))
                        resolve(data)
                    })
                } catch (error) {
                    console.log('getDeferredTasks error: < ' + error)
                    this.log('getDeferredTasks error: < ' + error)
                    reject(error)
                }
            })
        },
        addDeferredTask(params) {
            this.log('addDeferredTask: > ' + JSON.stringify(params))
            return new Promise(async (resolve, reject) => {
                try {
                    const data = await this._emitWithTimeOut('add-deferred-task', params, 5000)
                    resolve(data)
                } catch (error) {
                    // console.log('addDeferredTask error: < ' + error)
                    this.log('addDeferredTask error: < ' + error)
                    reject(error)
                }
            })
        },
        updateDeferredTask(params) {
            this.log('updateDeferredTask: > ' + JSON.stringify(params))
            return new Promise((resolve, reject) => {
                try {
                    this.socket.emit('update-deferred-task', params, (data) => {
                        this.log('updateDeferredTask: < ' + data.length)
                        resolve(data)
                    })
                } catch (error) {
                    console.log('updateDeferredTask error: < ' + error)
                    this.log('updateDeferredTask error: < ' + error)
                    reject(error)
                }
            })
        },
        deleteDeferredTasks(params) {
            this.log('deleteDeferredTasks: > ' + JSON.stringify(params))
            return new Promise((resolve, reject) => {
                try {
                    this.socket.emit('delete-deferred-tasks', params, (data) => {
                        this.log('deleteDeferredTasks: < ' + JSON.stringify(data))
                        resolve(data)
                    })
                } catch (error) {
                    console.log('deleteDeferredTasks error: < ' + error)
                    this.log('deleteDeferredTasks error: < ' + error)
                    reject(error)
                }
            })

        },
    },
    listeners: {
        'deferred-task-change-event'(data) {
            this.log('bind: < deferred-task-change-event: ' + JSON.stringify(data))
            this.emit('deferred-task-change-event', data)
        },
    },
}